import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionStore } from '../store/session.store';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private _store = inject(SessionStore);

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const isApiRequest = request.url.startsWith(environment.api);
		const isGenaiRequest = request.url.startsWith(environment.genai);

		if (!isApiRequest && !isGenaiRequest) {
			return next.handle(request);
		}

		const headers: Record<string, string> = {};
		const token = this._store.token();
		if (token) {
			headers['Authorization'] = `Bearer ${token}`;
		}

		if (isGenaiRequest) {
			const tenantId = this._store.tenant()?.id;
			if (tenantId) {
				headers['X-Barrows-Tenant'] = tenantId.toString();
			}
		}

		if (Object.keys(headers).length) {
			request = request.clone({ setHeaders: headers });
		}

		return next.handle(request);
	}
}
